<template>
	<div class="wais">
		<div class="wai">
			<div class="title">
				<div class="blue"></div>
				<div style="flex: 1;">加盟进度</div>
			</div>
			<el-form label-width="100px">
				<el-form-item label="加盟流程">
					<div class="process">
						<div class="processlist" v-for="(i,index) in checklist" :key="index">
							<div class="processlist1">
								<div class="pro_left">
									{{i.label}}
								</div>
								<div class="pro_right" v-if="i.value<=3">
									<img src="../../assets/rt.png" />
								</div>
							</div>
							<div class="processlist12">
								<el-radio class="checkeds" v-model="list.schedule" :label="i.value"></el-radio>
							</div>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="门店配置">
					<!-- <div  style="display: flex;">
						<div class="storeradio"><el-radio v-model="list.storeConfigure" label="1">新开门店</el-radio></div>
						<div class="storeradio"><el-radio v-model="list.storeConfigure" label="2">现有门店</el-radio></div>
						<div class="storeradio"><el-radio v-model="list.storeConfigure" label="3">更换门店</el-radio></div>
					</div> -->
					<div>
						<!-- <span style="margin-right: 15px;">选择门店</span> -->
						<!-- <el-select  filterable v-model="list.city" @change="citychange" style="width: 150px;" placeholder="请选择城市" size="small">
							<el-option
							v-for="item in city"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select> -->
						<!-- <el-select filterable v-model="list.store" style="width: 190px;margin-left: 30px;" placeholder="请选择门店" size="small">
							<el-option
								v-for="item in storelist"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select> -->
						<el-checkbox-group v-model="store" style="margin-left: 20px; width:800px">
							<span v-for="i in storelist" :key="i.value" style="display:inline-block; margin-left: 10px">
								<el-checkbox :label="i.value+''">{{ i.label }}</el-checkbox>
							</span>
						</el-checkbox-group>
					</div>
				</el-form-item>
				<!-- <el-form-item label="门店端配置" >
					<div class="peizhi">
						<div class="pz1">
							账号
						</div>
						<div>
							<el-input style="width: 300px;" v-model="list.adminPhone" size="small" placeholder="请输入管理员手机号"></el-input>
							<p class="pezhip">一件门店最多绑定3个账户</p>
						</div>
						<div>
							<el-button size="small" type="primary">确定</el-button>
						</div>
					</div>
					<div class="peizhi">
						<div class="pz1">
							账号权限
						</div>
						<div>
							<el-radio v-model="list.role" label="1">普通管理员</el-radio>
							<el-radio v-model="list.role" label="2">超级管理员</el-radio>
						</div>
					</div>
				</el-form-item> -->
				<el-form-item label="开店时间">
					<el-date-picker value-format="yyyy-MM-DD" type="date" size="small" v-model="list.openStore"
						placeholder="请选择开店时间"></el-date-picker>
				</el-form-item>
			</el-form>
			<div class="button_s" style="margin-left: 25%;">
				<el-button size="small" @click="goback">上一步</el-button>
				<el-button type="primary" @click="addsto" size="small">保 存</el-button>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				store: [],
				checklist: [{
					value: "0",
					label: "选址中"
				}, {
					value: "1",
					label: "装修中"
				}, {
					value: "2",
					label: "物资配送中"
				}, {
					value: "3",
					label: "确定营业"
				}, {
					value: "4",
					label: "开业"
				}],
				checked: [],
				list: {
					city: "",
					optiontime: "", //开店时间
					schedule: "",
					store: [],
					storeConfigure: "",
					adminPhone: "",
					openStore: "",
					role: "",
					stores: ""
				},
				city: [{
					value: "",
					label: "全部城市"
				}],
				//状态
				storelist: [],
			}
		},
		mounted() {
			this.getstorelist()
			// 获取城市列表
			const provinces = require('province-city-china/dist/city.json');
			this.city = [{
				value: "",
				label: "全部城市"
			}]
			for (let i = 1; i <= provinces.length; i++) {
				var a = {
					label: provinces[i - 1].name,
					value: provinces[i - 1].name
				}
				this.city.push(a)
			}
			var oid = localStorage.getItem('sid')
			this.list = JSON.parse(localStorage.getItem('addfriends'));
			this.list.schedule = this.list.schedule.toString()
			this.list.storeConfigure = this.list.storeConfigure.toString()
			this.list.role = this.list.role.toString()
			// this.list.stores=this.storelist[this.list.stores]
		},
		methods: {
			goback() {
				var arr = JSON.parse(localStorage.getItem('addfriends'))
				arr.role = this.list.role
				arr.schedule = this.list.schedule
				arr.store = this.list.store
				arr.storeConfigure = this.list.storeConfigure
				arr.openStore = this.list.openStore
				localStorage.setItem("addfriends", JSON.stringify(arr))
				this.$router.push({
					path: '/newjoin',
					query: {
						demo: 1
					}
				})
			},
			// 当城市发生改变的时候改变店铺列表
			citychange() {
				this.getstorelist()
			},
			// 获取门店列表
			getstorelist() {
				this.storelist = []
				this.$http.get("store/list?&page=1&size=9999&title=" + this.list.city).then(function(res) {
					if (res.body.code == "200") {
						for (let i in res.body.data.rows) {
							if (res.body.data.rows[i].businessType == 0) {
								let a = {
									value: res.body.data.rows[i].id,
									label: res.body.data.rows[i].title
								}
								this.storelist.push(a)
							}
						}
					} else {
						this.$message.error("请求失败")
					}
				})
			},
			// 添加门店
			addsto() {
				var arr = JSON.parse(localStorage.getItem('addfriends'))
				if (this.list.openStore == "" || this.list.schedule == "" || this.list.storeConfigure == "" || this.store
					.length == 0 || this.list.role == "") {
					return this.$message.error("请填写完整！");
				} else {
					arr.role = this.list.role
					arr.schedule = this.list.schedule
					arr.store = this.store.toString()
					arr.storeConfigure = this.list.storeConfigure
					arr.openStore = this.list.openStore
					this.$http.post("store/saveFranchisees", JSON.stringify(arr)).then(function(res) {
						if (res.body.code == "200") {
							this.$message.success("保存成功")
							this.list = {
								city: "",
								optiontime: "", //开店时间
								schedule: "",
								store: [],
								storeConfigure: "",
								adminPhone: "",
								openStore: "",
								role: ""
							}
							localStorage.removeItem("addfriends")
							this.$router.push({
								path: 'storeList',
								query: {
									id: 2
								}
							})
						}
					})
				}
			},
		}
	};
</script>
<style lang="less" scoped>
	.peizhi {
		display: flex;

		>div {
			margin-left: 20px;

			.pezhip {
				line-height: 0;
				font-size: 12px;
				color: #AAAAAA;
			}
		}
	}

	.process {
		display: flex;
		width: 80%;

		.processlist {
			margin-left: 30px;

			.processlist1 {
				display: flex;

				.pro_left {
					width: 109px;
					height: 43px;
					background-color: #D7D7D7;
					text-align: center;
				}

				.pro_right {
					margin-left: 20px;

					img {
						width: 35px;
					}
				}
			}
		}
	}

	.headlike {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		overflow: hidden;
	}

	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		margin-right: 32%;
	}

	.button_s {
		margin-left: 100px;
	}

	// 
	.list1 {
		>div {
			padding-left: 50px;

			p {
				width: 233px;
				height: 47px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C8C8C8;
				line-height: 2.1;
			}
		}
	}

	.heads {
		line-height: 1;
	}

	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.wais {
		display: flex;
	}

	/deep/.checkeds {
		width: 23px;
		overflow: hidden;
		margin-left: 45px;
	}

	.storeradio {
		margin-left: 30px;
	}
</style>